import Index from '../../pages/mitu/special/index';

const base = 'special';

const routes = [{
        path: `/${base}/index`,
        name: `${base}-index`,
        component: Index
    },
    {
        path: `/${base}/enter*`,
        name: `${base}-enter`,
        component: Index
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/mitu/special.js